import React, { Fragment, useEffect, useState } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import Loader  from "~/components/loader";

import security from "~/services/security";
import Survey   from "~/services/surveys";


const CpxResearch = ({})=> {

  const currentUser = security.currentUserValue;
  const cpxAppId = 9946;

  const [isLoading , setIsLoading] = useState(true);
  const [hash      , setHash]      = useState("");

  useEffect(()=> {
    (async ()=> {
      document.body.style.overflow = "hidden";
      setHash(await Survey.generateCpxHash());
      setIsLoading(false);
    })();
  }, []);

  return (
    <Fragment>
      <Backbar path="/surveys" showLogo={false} />
      { isLoading ? <Loader type={19} center style={{marginTop: 150}} /> :
        <iframe
          width="100%"
          frameBorder="0"
          style={{height: "80vh"}}
          src={`https://offers.cpx-research.com/index.php?app_id=${cpxAppId}&ext_user_id=${currentUser.id}&secure_hash=${hash}&username=${currentUser.firstName} ${currentUser.lastName}&email=${currentUser.email}`}
        ></iframe> }
    </Fragment>
  );
};

export default CpxResearch;
